import { Add } from '@mui/icons-material';
import { Tooltip, MenuItem, Typography } from '@mui/material';

import { MouseEventHandler } from 'react';
import useStyles from './styles';

type WorkspacesHeaderProps = {
  title: string;
  tooltip: string;
  onClick?: MouseEventHandler;
  disabled?: boolean;
};

export const WorkspacesHeader = ({ title, tooltip, onClick, disabled }: WorkspacesHeaderProps) => {
  const classes = useStyles();
  return (
    <Tooltip title={tooltip} placement='left'>
      <MenuItem onClick={onClick} className={classes.workspaceMenuItem}>
        <Typography variant='h5'>{title}</Typography>
        {!disabled && <Add fontSize='small' sx={{ ml: 'auto' }} />}
      </MenuItem>
    </Tooltip>
  );
};
